import React, {Component} from 'react';
import { Tabs, ListView, Picker } from 'antd-mobile';
import '../../res/style/myEnroll.less';
import Config from "../../config";

import EnrollList from './components/EnrollList';
import {inject, observer} from "mobx-react/index";
import WxApi from "../../common/wxapi";
import { withAppBasename } from "../../common/router";

@inject("myEnrollStore", "enrollStore")
@observer
class App extends Component {
    state = {
        enrollList: [],
        isWeixin: true,
        isMobile: true,
        isUnionPay: false,
        currentPage: 1,
        currentType: 0,
        loadMore: false,
        refreshing: false,
        userInfo: {},
        deactivate: '正在加载中...',
        height: document.documentElement.clientHeight,
        showDialog: true,
        cancel_status: -1,
        cancelText: '全部',
        district: [
            {label: '全部', value: -1},
            {label: '已核销', value: 1},
            {label: '未核销', value: 0},
        ],
        pick_status: 0,
        pickList: [
            {label: '全部', value: 0},
            {label: '进行中', value: 1},
            {label: '未开始', value: 2},
            {label: '已截止', value: 3},
            {label: '我管理的', value: 5},
            {label: '我发起的', value: 6}
        ],
        pickText: '全部',
        time_status: 1,
        timeList: [
            {label: '按截止时间倒序', value: 1},
            {label: '按创建时间倒序', value: 2},
        ],
        showHeader: false,
        overDay: 0,
        expire_bak_total: 0,
    };

    getPageFromQuery = () => {
        const page = Number(WxApi.getQueryString('page') || 1);
        return page > 0 ? page : 1;
    };

    buildPagePath = (page, tab = this.state.currentType) => {
        return `/manage/myEnroll?tab=${tab}&page=${page}`;
    };

    buildPageHref = (page, tab = this.state.currentType) => {
        return withAppBasename(this.buildPagePath(page, tab));
    };

    updatePageUrl = (page = this.state.currentPage, tab = this.state.currentType) => {
        if (tab === 0) {
            this.props.history.replace('/manage/myEnroll');
            return;
        }
        this.props.history.replace(this.buildPagePath(page, tab));
    };

    setHeadLink = (rel, href) => {
        const selector = `link[data-seo-pagination="${rel}"]`;
        let element = document.head.querySelector(selector);

        if (!href) {
            if (element) element.remove();
            return;
        }

        if (!element) {
            element = document.createElement('link');
            element.setAttribute('rel', rel);
            element.setAttribute('data-seo-pagination', rel);
            document.head.appendChild(element);
        }

        element.setAttribute('href', `${window.location.origin}${href}`);
    };

    syncPaginationHead = () => {
        if (this.state.currentType === 0) {
            this.setHeadLink('prev', '');
            this.setHeadLink('next', '');
            return;
        }

        const prevHref = this.state.currentPage > 1
            ? this.buildPageHref(this.state.currentPage - 1, this.state.currentType)
            : '';
        const nextHref = this.state.loadMore
            ? this.buildPageHref(this.state.currentPage + 1, this.state.currentType)
            : '';

        this.setHeadLink('prev', prevHref);
        this.setHeadLink('next', nextHref);
    };

    componentDidMount() {
        document.title = '我的记录';
        if (!Config.TOKEN) return;

        this.props.enrollStore.getUserInfo().then(() => {
            let {userInfo} = this.props.enrollStore;
            if (userInfo.expire && userInfo.auth_status == 4) {
                const nowDate = new Date().getTime();
                const endTimer = new Date(userInfo.expire).getTime();
                const diffTime = nowDate - endTimer;
                this.state.overDay = Math.ceil(diffTime / 1000 / 60 / 60 / 24);
            }
            sessionStorage.setItem('unionid', userInfo.unionid);
            this.setState({userInfo, overDay: this.state.overDay});
        });

        let tabIndex = sessionStorage.getItem('tabIndex') || 0;
        if (WxApi.getQueryString('tab')) {
            tabIndex = WxApi.getQueryString('tab');
        }
        this.changeTab(Number(tabIndex), this.getPageFromQuery(), false);

        window.addEventListener('scroll', () => {
            if (this.state.currentType == 1 || this.state.currentType == 2) {
                const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (top > 100 && !this.state.showHeader) {
                    this.setState({showHeader: true});
                } else if (top == 0 && this.state.showHeader) {
                    this.setState({showHeader: false});
                }
            }
        }, true);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.currentPage !== this.state.currentPage ||
            prevState.currentType !== this.state.currentType ||
            prevState.loadMore !== this.state.loadMore
        ) {
            this.syncPaginationHead();
        }
    }

    componentWillUnmount() {
        this.setHeadLink('prev', '');
        this.setHeadLink('next', '');
    }

    renderPaginationNav() {
        if (this.state.currentType === 0) {
            return null;
        }

        const totalPages = this.state.loadMore ? this.state.currentPage + 1 : this.state.currentPage;
        if (totalPages <= 1) {
            return null;
        }

        const startPage = Math.max(1, this.state.currentPage - 1);
        const endPage = Math.min(totalPages, this.state.currentPage + 1);
        const pages = [];

        for (let page = startPage; page <= endPage; page += 1) {
            pages.push(page);
        }

        // return (
        //     <nav aria-label="分页" style={{display: 'flex', justifyContent: 'center', gap: '8px', flexWrap: 'wrap', padding: '12px 0 4px'}}>
        //         {this.state.currentPage > 1 ? (
        //             <a href={this.buildPageHref(this.state.currentPage - 1)} style={{color: '#00a8f3', textDecoration: 'none'}}>上一页</a>
        //         ) : null}
        //         {pages.map((page) => (
        //             <a
        //                 key={page}
        //                 href={this.buildPageHref(page)}
        //                 style={{
        //                     color: page === this.state.currentPage ? '#fff' : '#00a8f3',
        //                     backgroundColor: page === this.state.currentPage ? '#00a8f3' : 'transparent',
        //                     border: '1px solid #00a8f3',
        //                     borderRadius: '16px',
        //                     minWidth: '32px',
        //                     lineHeight: '30px',
        //                     padding: '0 10px',
        //                     textDecoration: 'none'
        //                 }}
        //             >
        //                 {page}
        //             </a>
        //         ))}
        //         {this.state.loadMore ? (
        //             <a href={this.buildPageHref(this.state.currentPage + 1)} style={{color: '#00a8f3', textDecoration: 'none'}}>下一页</a>
        //         ) : null}
        //     </nav>
        // );
    }

    render() {
        const tabs2 = [
            { title: '最近浏览', sub: '1' },
            { title: '我管理的', sub: '2' },
            { title: '我参与的', sub: '3' },
            { title: '我关注的', sub: '4' }
        ];

        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        const dataSource = ds.cloneWithRows(this.state.enrollList.slice());

        const row = () => null;

        return (
            <div className="main-enroll-box">
                <div className="tab-box" style={{WebkitOverflowScrolling: 'touch'}}>
                    {this.state.currentType == 0 || this.state.currentType == 1 ? (
                        <div className='search-items recycle-box' style={{display: 'flex', marginRight: 0, pointerEvents: 'none'}}>
                            <a className='cen-recycle' style={{pointerEvents: 'auto', color: 'inherit', textDecoration: 'none'}} href={withAppBasename('/recycleBin')} onClick={(e) => {
                                e.stopPropagation();
                            }}>
                                <img className='icon-delete' src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20241220/734a57eca0cd0dd7f0d1aeabd42c9384.png"></img>
                                {this.state.expire_bak_total > 0 ? (
                                    <span className='recycle-total'>{this.state.expire_bak_total > 99 ? '99' : this.state.expire_bak_total}</span>
                                ) : ''}
                                <span>回收站</span>
                            </a>
                        </div>
                    ) : null}

                    <Tabs tabs={tabs2} page={this.state.currentType} onChange={(tab, index) => { this.changeTab(index); }} swipeable={false}></Tabs>

                    {this.state.currentType == 2 ? (
                        <div className={this.state.showHeader ? 'search-box fixed-search-header' : 'search-box'}>
                            <Picker data={this.state.district} cols={1} onChange={(val) => {
                                const i = this.state.district.findIndex(e => val[0] == e.value);
                                this.setState({
                                    cancel_status: val[0],
                                    cancelText: this.state.district[i].label,
                                    enrollList: [],
                                    currentPage: 1,
                                    refreshing: false,
                                }, () => {
                                    this.updatePageUrl(1, this.state.currentType);
                                    this.getManageData();
                                });
                            }}>
                                <span className='select-btn'>{this.state.cancelText}</span>
                            </Picker>
                            <a className='down-btn' href={withAppBasename('/deleted-data')} style={{color: 'inherit', textDecoration: 'none'}}>
                                <i className='icon-down iconfont icon-xiazai1'></i>
                                <span>已删除数据</span>
                            </a>
                            <a className='search-btn' href={withAppBasename('/searchEnroll?type=myEnroll')} style={{color: 'inherit', textDecoration: 'none'}}>
                                <i className='iconfont icon-sousuo1'></i>
                                <span>搜索</span>
                            </a>
                        </div>
                    ) : ''}

                    {this.state.currentType == 1 ? (
                        <div className={this.state.showHeader ? 'search-box fixed-search-header' : 'search-box'}>
                            <Picker data={this.state.pickList} value={[this.state.pick_status]} cols={1} onChange={(val) => {
                                const i = this.state.pickList.findIndex(e => val[0] == e.value);
                                this.setState({
                                    pick_status: val[0],
                                    pickText: this.state.pickList[i].label,
                                    enrollList: [],
                                    currentPage: 1,
                                    refreshing: false,
                                }, () => {
                                    this.updatePageUrl(1, this.state.currentType);
                                    this.getManageData();
                                });
                            }}>
                                <span className='select-btn pick-btn'>{this.state.pickText}</span>
                            </Picker>
                            <Picker data={this.state.timeList} value={[this.state.time_status]} cols={1} onChange={(val) => {
                                this.setState({
                                    time_status: val[0],
                                    enrollList: [],
                                    currentPage: 1,
                                    refreshing: false,
                                }, () => {
                                    this.updatePageUrl(1, this.state.currentType);
                                    this.getManageData();
                                });
                            }}>
                                <span className='select-btn pick-btn'>{this.state.timeList[this.state.time_status - 1].label}</span>
                            </Picker>
                            <a className='search-items' href={withAppBasename('/searchEnroll?type=myEnroll&time_type=11')} style={{color: 'inherit', textDecoration: 'none'}}>
                                <i className='iconfont icon-sousuo1'></i>
                                <span>搜索</span>
                            </a>
                            {this.state.currentType == 1 && this.state.userInfo.auth_status != 2 ? (
                                <img className='auth-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-21/6dc527d9fac958a6c7430868f5ff7316.png' onClick={() => {
                                    sessionStorage.setItem('sourceType', 'change_name_count_myenroll');
                                    this.props.history.push('/auth');
                                }}></img>
                            ) : null}
                        </div>
                    ) : ''}

                    <ListView
                        style={{minHeight: '101%'}}
                        ref={el => this.lv = el}
                        dataSource={dataSource}
                        renderFooter={() => (
                            <div style={{textAlign: 'center'}}>
                                {this.state.deactivate}
                                {this.renderPaginationNav()}
                            </div>
                        )}
                        renderRow={row}
                        renderBodyComponent={() => <EnrollList enrollList={this.state.enrollList} userInfo={this.state.userInfo} currentType={this.state.currentType} expire_bak_total={this.state.expire_bak_total} changeData={this.ChildrenChange.bind(this)}/>}
                        useBodyScroll={true}
                        pageSize={20}
                        scrollRenderAheadDistance={100}
                        onEndReachedThreshold={20}
                        onEndReached={() => { this.refreshData(); }}
                    />
                </div>
            </div>
        );
    }

    ChildrenChange(val, index) {
        this.state.enrollList[index].isOpen = val;
        this.setState({
            enrollList: this.state.enrollList
        });
    }

    refreshData() {
        if (this.state.loadMore && this.state.currentType) {
            const nextPage = this.state.currentPage + 1;
            this.setState({
                refreshing: true,
                currentPage: nextPage,
            }, () => {
                this.updatePageUrl(nextPage, this.state.currentType);
                this.state.currentType == 3 ? this.getSubData() : this.getManageData();
            });
        }
    }

    changeTab(index, page = 1, shouldUpdateUrl = true) {
        sessionStorage.setItem('tabIndex', index);
        this.setState({
            currentPage: index === 0 ? 1 : page,
            enrollList: [],
            currentType: index,
            refreshing: false,
            loadMore: false,
            pick_status: 0,
            time_status: 1,
            cancel_status: -1,
            cancelText: '全部',
            pickText: '全部',
        }, () => {
            if (index == 0) {
                this.oldTab = index;
                if (shouldUpdateUrl) {
                    this.updatePageUrl(1, index);
                }
                this.getEnrollData();
            } else if (index == 3) {
                sessionStorage.setItem('tabIndex', this.oldTab);
                this.setState({currentType: this.oldTab}, () => {
                    if (this.state.currentType == 0) {
                        this.getEnrollData();
                    } else {
                        this.getManageData();
                    }
                });
                React.$wx.jumpNewPath.call(this, '/recommend');
            } else {
                this.oldTab = index;
                if (shouldUpdateUrl) {
                    this.updatePageUrl(page, index);
                }
                this.getManageData();
            }
        });
    }

    getManageData() {
        const params = {
            count: 20,
            page: this.state.currentPage,
            type: this.state.currentType == 1 ? 0 : 1,
            time_out: this.state.time_status
        };

        if (this.state.pick_status == 5) {
            params.type = 10;
            params.status = 0;
            params.is_create = 2;
        } else if (this.state.pick_status == 6) {
            params.type = 10;
            params.status = 0;
            params.is_create = 1;
        } else if (this.state.pick_status > 0) {
            params.status = this.state.pick_status;
            params.type = 10;
        }

        if (this.state.currentType == 2) params.cancel_status = this.state.cancel_status;

        this.props.myEnrollStore.getManageList(params).then(res => {
            if (res.sta == 0) {
                let listData = res.data || [];
                let loadMore = false;
                let deactivate = '正在加载中...';
                if (listData.length == 20) {
                    loadMore = true;
                } else {
                    deactivate = '';
                }
                listData.forEach(item => {
                    item.cert_length = item.cert_list ? item.cert_list.length : 0;
                    item.isOpen = false;
                });
                listData = WxApi.getAutoImage(listData, 150);
                const data = this.state.refreshing ? this.state.enrollList.concat(listData) : listData;
                this.setState({
                    enrollList: data,
                    loadMore,
                    refreshing: false,
                    deactivate,
                    expire_bak_total: res.expire_bak_total,
                });
            }
        });
    }

    getEnrollData() {
        this.props.myEnrollStore.getEnrollHistory().then(res => {
            if (res.sta == 0) {
                this.setState({
                    enrollList: WxApi.getAutoImage(res.data, 150),
                    expire_bak_total: res.bak_total,
                    deactivate: '',
                    loadMore: false,
                });
            }
        });
    }

    getSubData() {
        const params = {
            page: this.state.currentPage,
            count: 20
        };
        this.props.myEnrollStore.getSubList(params).then(res => {
            if (res.sta == 0) {
                let loadMore = false;
                let deactivate = '正在加载中...';
                if (res.data.users.length == 20) {
                    loadMore = true;
                } else {
                    deactivate = '';
                }
                res.data.users = WxApi.changeLocalImage(res.data.users);
                const data = this.state.enrollList.concat(res.data.users);
                this.setState({
                    enrollList: data,
                    loadMore,
                    refreshing: false,
                    deactivate,
                });
            }
        });
    }
}

export default App;
